import { useEffect, useState } from 'react';

// BL-177 Step 2j (E): true when the person's device asks for reduced motion. Components that slide or animate (the Settings
// tile slide, the 3-position switch knob) use it to render NO motion class at all; the CSS also has a
// prefers-reduced-motion rule as a second line. Safe where matchMedia does not exist (older test DOMs): then motion is allowed.
const QUERY = '(prefers-reduced-motion: reduce)';

export function readPrefersReducedMotion() {
    try {
        return Boolean(typeof window !== 'undefined' && window.matchMedia && window.matchMedia(QUERY).matches);
    } catch (_ignored) {
        return false;
    }
}

export default function usePrefersReducedMotion() {
    const [reduced, setReduced] = useState(readPrefersReducedMotion);
    useEffect(() => {
        let media;
        try { media = window.matchMedia ? window.matchMedia(QUERY) : null; } catch (_ignored) { media = null; }
        if (!media) return undefined;
        const update = () => setReduced(Boolean(media.matches));
        update();
        if (media.addEventListener) media.addEventListener('change', update);
        else if (media.addListener) media.addListener(update);
        return () => {
            if (media.removeEventListener) media.removeEventListener('change', update);
            else if (media.removeListener) media.removeListener(update);
        };
    }, []);
    return reduced;
}
